import { Editor } from 'tinymce';

// TODO DEV-NOTE: Check link for reference https://www.mugo.ca/Blog/Automating-curly-quotes-in-rich-text-fields
export const curlyQuotesCmn = (editor: Editor) => {
  const strText = editor.getContent({ format: 'text', no_events: true });
  // TODO DEV-NOTE: Check if content have single or double quotes
  if (strText.indexOf("'") === -1 && strText.indexOf('"') === -1) {
    return;
  }

  // TODO DEV-NOTE: Will bookmark the curson position
  const lastSelection = editor.selection.getBookmark();

  // TODO DEV-NOTE: Read the content from the element
  let str = editor.getContent({ format: 'raw', no_events: true });

  // TODO DEV-NOTE: Open singles
  str = str.replace(
    /(^')|((([\s{\[\(>]')|([\s>]"'))(?!([^<])*?>)(?!<script[^>]*?>)(?![^<]*?<\/script>|$))/gi,
    ($1$2) => {
      return $1$2.replace(/'/g, '\u2018');
    },
  );

  // TODO DEV-NOTE: Closing singles + apostrophes
  str = str.replace(
    /'(?!([^<])*?>)(?!<script[^>]*?>)(?![^<]*?<\/script>|$)/gi,
    '\u2019',
  );

  // TODO DEV-NOTE: Open doubles
  str = str.replace(
    /(^")|((([\s{\[\(>]")|([\s>]'"))(?!([^<])*?>)(?!<script[^>]*?>)(?![^<]*?<\/script>|$))/gi,
    ($1$2) => {
      return $1$2.replace('"', '\u201c');
    },
  );

  // TODO DEV-NOTE: Closing doubles
  str = str.replace(
    /"(?!([^<])*?>)(?!<script[^>]*?>)(?![^<]*?<\/script>|$)/g,
    '\u201d',
  );

  // TODO DEV-NOTE: Update the element content
  editor.execCommand('mceSetContent', false, str);
  editor.selection.moveToBookmark(lastSelection);
};
